import { ReactElement, useState, useMemo } from 'react';
import SpeedFilter from './SpeedFilter';
import Histogram from './Histogram';
import { getChannel } from '../../../utils/channelNamesGridded';

function YawHistogram(props: { run: { data_gridded: any }; calibration: any }): ReactElement {
  const data_gridded = props.run.data_gridded || {};
  const calibration = props.calibration;

  if (!getChannel(data_gridded, 'AirYaw_AG31_Absolute', calibration)) {
    return <div>This run has no yaw position or rate data</div>;
  }

  const [data, setData] = useState();

  const filterFields = useMemo(
    () => [
      {
        fieldName: 'RoadSpeed',
        displayName: 'Speed',
        min: 0,
        max: 50,
        step: 1,
        unit: 'km/h',
        conversionFactor: 1,
        defaultValue: 30,
      },
    ],
    [],
  );

  const dataFields = useMemo(
    () => [
      {
        fieldName: 'AirYaw_AG31_Absolute',
        displayName: 'Yaw Position',
      },
    ],
    [],
  );

  return (
    <div className="cr-mb-5 cr-overflow-hidden cr-rounded-xl cr-bg-clip-border cr-p-5 cr-shadow-md">
      {data && (
        <div className="cr-flex cr-flex-row">
          <div className="cr-basis-11/12">
            <Histogram
              data={data}
              title="YAW Distribution"
              series={[{ fieldName: 'AirYaw_AG31_Absolute', displayName: 'Percentage at Yaw' }]}
              thresholds={() => Array.from({ length: 21 }, (_, i) => i)} // [-7,-6,-5,-4,-3,-2,-1,0,1,2,3,4,5,6,7]
              unit="°"
            />
          </div>
        </div>
      )}
      <SpeedFilter
        rawData={data_gridded}
        setData={setData}
        calibration={calibration}
        filterFields={filterFields}
        dataFields={dataFields}
      />
    </div>
  );
}

export default YawHistogram;
